import React, { useEffect, useState } from 'react';
import { Drawer, Divider } from '@lana-ui/common';
import Header from './Header';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './drawer-accordion.scss';

const propTypes = {
    /**
     * Titulo de la página
     */
    title: PropTypes.string,
    /**
     * Texto secundario
     */
    subtitle: PropTypes.string,
    /**
     * Color de fondo
     */
    backgroundColor: PropTypes.oneOf(['gray', 'white', '']),
    /**
     * Distancia entre el texto el botón arrow del header.
     */
    headerElementsDistance: PropTypes.oneOf(['small', 'large', '']),
    /**
     * Titulo en negrita
     */
    titleBold: PropTypes.bool,
    /**
     * Divider después del Header
     */
    headerWithoutDivider: PropTypes.bool,
    /**
     * Clases adicionales.
     */
    className: PropTypes.string,
    /**
     * bool pantalla de gracias para extender drawer.
     */
    isConfirmacion: PropTypes.bool,
    /**
     * bool para extender drawer por defecto.
     */
    openedDrawer: PropTypes.bool,
};

const DrawerAccordion = ({ title, subtitle, backgroundColor, headerElementsDistance, titleBold, headerWithoutDivider, children, className, isConfirmacion, openedDrawer }) => {
    const classes = classNames('lgn-drawer-accordion', className, {
        [`--${backgroundColor}`]: backgroundColor,
        [`--${headerElementsDistance}`]: headerElementsDistance,
        '--header-without-divider': headerWithoutDivider,
    });
    const [showDrawer, setShowDrawer] = useState(false);

    const handleToggleAccordion = () => {
        setShowDrawer(!showDrawer)
        if (showDrawer) {
            document.body.classList.remove("modal-active")
        } else {
            document.body.classList.add("modal-active")
        }
    }

    useEffect(() => {
        openedDrawer && setShowDrawer(isConfirmacion);
    }, [isConfirmacion]);

    return (
        <div className={classes}>
            <Header title={title} subtitle={subtitle} buttonIcon="arrowUp" onClick={handleToggleAccordion} titleBold={titleBold} />

            {showDrawer && (
                <Drawer direction="bottom" buttonBackgroundNone isOpen={showDrawer}>
                    <div className="drawer-accordion-content">
                        <Header title={title} subtitle={subtitle} buttonIcon="arrowDown" onClick={handleToggleAccordion} titleBold={titleBold} />
                        <Divider />
                        {children}
                    </div>
                </Drawer>
            )}
        </div>
    );
};

DrawerAccordion.propTypes = DrawerAccordion;

export default DrawerAccordion;
